<template>
  <div class="main mainQMultiple mainT2">
      <div class="testT-section testT2 testOver">
          <ul id="test5-ul">
              <li :class="[position === 1 ? 'vueActive' : 'vueLiNone']">
                 <!--<div class="labelPerso"> </div>
                    
                    <div class="selectPerso" id="general" @click="selectClick(1)" :data-value="this.select[1].option">
                        <p>{{ this.select[1].value }} </p>
                        <div class="iconeSelect">
                        <i v-if="this.select[1].click == false" class="fa fa-angle-down white"></i>
                        <i v-if="this.select[1].click == true" class="fa fa-angle-up white"></i>
                        </div>
                    </div><div :class="[select[1].click == true ? 'optionVisible' : 'optionHide', 'optionGeneral']">
                        <div class="optionPerso general" @click="selectOption(1, 3)">très actif et de caractère sportif</div>
                        <div class="optionPerso general" @click="selectOption(1, 2)">moyennement actif physiquement</div>
                        <div class="optionPerso general" @click="selectOption(1, 1)">plutôt peu actif physiquement</div>
                        <div class="optionPerso general" @click="selectOption(1, 0)">franchement sédentaire</div>
                    </div>-->
                    <h4>Vous considérez-vous comme :</h4>
                    <ul class="modeleBase">
                        <li class="optionPerso general">
                          <button :class="[{selected: select[1].click === 3}]" @click="selectOption(1, 3)">
                            <p>très actif et de caractère sportif</p>
                          </button>
                        </li>
                        <li class="optionPerso general">
                          <button :class="[{selected: select[1].click === 2}]" @click="selectOption(1, 2)">
                            <p>moyennement actif physiquement</p>
                          </button>
                        </li>
                        <li class="optionPerso general">
                          <button :class="[{selected: select[1].click === 1}]" @click="selectOption(1, 1)">
                            <p>plutôt peu actif physiquement</p>
                          </button>
                        </li>
                        <li class="optionPerso general">
                          <button :class="[{selected: select[1].click === 0}]" @click="selectOption(1, 0)">
                            <p>franchement sédentaire</p>
                          </button>
                        </li>
                    </ul>
                </li>

                <li :class="[position === 2 ? 'vueActive vueActive2' : 'vueLiNone']">
                    <h4>Considérez-vous que vos activités quotidiennes (sociales et/ou professionnelles : déplacements, manutentions, bricolage, courses, ménages, vaisselle, repassag.) correspondent :</h4>
                    <ul class="modeleBase">
                        <li class="optionPerso general">
                          <button :class="[{selected: select[2].click === 3}]" @click="selectOption(2, 3)">
                            <p>à une sollicitation physique intense</p>
                          </button>
                        </li>
                        <li class="optionPerso general">
                          <button :class="[{selected: select[2].click === 2}]" @click="selectOption(2, 2)">
                            <p>à une sollicitation physique moyenne</p>
                          </button>
                        </li>
                        <li class="optionPerso general">
                          <button :class="[{selected: select[2].click === 1}]" @click="selectOption(2, 1)">
                            <p>à une sollicitation physique modérée</p>
                          </button>
                        </li>
                        <li class="optionPerso general">
                          <button :class="[{selected: select[2].click === 0}]" @click="selectOption(2, 0)">
                            <p>à l’absence de sollicitation physique véritable</p>
                          </button>
                        </li>
                    </ul>
                </li>
                    
                <li :class="[position === 3 ? 'vueActive' : 'vueLiNone']">
                  <h4>Vos activités quotidiennes vous prennent environ :</h4>
                    <ul class="modeleBase">
                        <li class="optionPerso activite_quoti">
                          <button :class="[{selected: select[3].click === 3}]" @click="selectOption(3, 4)">
                            <p>plus de 10 heures par semaine</p>
                          </button>
                        </li>
                        <li class="optionPerso activite_quoti">
                          <button :class="[{selected: select[3].click === 2}]" @click="selectOption(3, 3)">
                            <p>entre 6 et 10 heures par semaine</p>
                          </button>
                        </li>
                        <li class="optionPerso activite_quoti">
                          <button :class="[{selected: select[3].click === 2}]" @click="selectOption(3, 2)">
                            <p>entre 2 et 6 heures par semaine</p>
                          </button>
                        </li>
                        <li class="optionPerso activite_quoti">
                          <button :class="[{selected: select[3].click === 1}]" @click="selectOption(3, 1)">
                            <p>moins de 2 heures par semaine</p>
                          </button>
                        </li>
                        <li class="optionPerso activite_quoti">
                          <button :class="[{selected: select[3].click === 0}]" @click="selectOption(3, 0)">
                            <p>aucun temps consacré par semaine</p>
                          </button>
                        </li>
                    </ul>
                </li>
                <li :class="[position === 4 ? 'vueActive' : 'vueLiNone']">
                    <h4>L’activité sportive ou de loisir que vous exercez est :</h4>
                    <ul class="modeleBase">
                        <li class="optionPerso activite_sportive">
                          <button :class="[{selected: select[4].click === 3}]" @click="selectOption(4, 3)">
                            <p>de forte intensité : fatigue musculaire importante</p>
                          </button>
                        </li>
                        <li class="optionPerso activite_sportive">
                          <button :class="[{selected: select[4].click === 2}]" @click="selectOption(4, 2)">
                            <p>d’intensité modérée : fatigue musculaire modérée</p>
                          </button>
                        </li>
                        <li class="optionPerso activite_sportive">
                          <button :class="[{selected: select[4].click === 1}]" @click="selectOption(4, 1)">
                            <p>d’intensité légère : sans fatigue musculaire</p>
                          </button>
                        </li>
                        <li class="optionPerso activite_sportive">
                          <button :class="[{selected: select[4].click === 0}]" @click="selectOption(4, 0)">
                            <p>vous n’en exercez pas</p>
                          </button>
                        </li>
                    </ul>
                </li>
          </ul>
      </div>
  </div>
</template>

<script>
export default {
  name: "Test_5",
  data() {
    return {
      select: { 1 : {click : false, option : 3, id :"general", value:"très actif et de caractère sportif"}, 
                2 : {click : false, option : 3, id:"quotidien", value:"à une sollicitation physique intense"}, 
                3 : {click : false, option : 4, id:"activite_quoti", value:"plus de 10 heures par semaine"}, 
                4 : {click : false, option : 3, id :"activite_sportive", value :"de forte intensité : fatigue musculaire importante"}
                },
      position: 1,
      resultat5:0,
    };
  },/*
  created() {
      for (let elements in this.select) {
       var options = document.getElementsByClassName(this.select[elements].id);
        var contenu = [];
        var option = this.select[elements].option;
        Object.keys(options).forEach(function (element, index) {
         contenu.unshift(options[element].textContent);
      });
      console.log (contenu[option], option);
       this.select[elements].value = contenu[option]; 
      };
  },*/
  methods: {
    selectClick(selected, position){
      if (this.select[selected].click == false){
        this.select[selected].click = position;
      }else {
        this.select[selected].click = false;
      }
    },
    valueOption(liste, id){
      var options = document.getElementsByClassName(id);
      var contenu = [];
      var option = this.select[liste].option;
      Object.keys(options).forEach(function (element, index) {
         contenu.unshift(options[element].textContent);
      });
      //console.log (contenu[option], option);

      this.select[liste].value = contenu[option];
      this.resultat5 += option;
      return contenu[option];
    },
    selectOption(liste, optionC){
      this.selectClick(liste, optionC);
      this.select[liste].option = optionC;
      this.valueOption(liste, this.select[liste].id);

      this.position++;
      this.select[liste].click = false;
      if (liste == 4){
        console.log(this.resultat5);
        localStorage.vive = this.resultat5;
        this.$emit('choice5');
      }
    }
  },
  sauvegardePlus(){
       var corps = document.getElementsByClassName('selected');
      
        if (this.position == 1){
          var array = [];
        }else{
          var array = JSON.parse(localStorage.indicateur4);
        }
        if (this.position == 1){
          array.push({'nbArret':this.douleur.arret});
        }else if (this.position == 2){
          array.push({'dureeArret':this.douleur.arretTotal});
        }else if (this.position == 3){
          array.push({'pec':this.douleur.pec}); 
                let valider = document.getElementsByClassName('submitQuestionnaire');
      
      Object.keys(valider).forEach(function (element, index) {
          valider[element].style.visibility = 'visible';
        }); 
        }else if (this.position == 4){
 
        }
      localStorage.indicateur4 = JSON.stringify(array);
      console.log(localStorage.indicateur4)
      this.position++;
    },
    actived (nb){
      if (this.activetab[6] == false){
        this.activetab[nb] = !this.activetab[nb];
        if (nb == 6){
          alert('Attention si vous voulez choisir une autre réponse, désélectionner "aucun"');
          for (let i = 1; i < 6; i++) {
          this.activetab[i] = false;
          }
        }
      }else if (nb == 6 && this.activetab[6] == true){
          this.activetab[nb] = !this.activetab[nb]; 
        }
  },
};
</script>
<style>
.modeleBase{
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  list-style: none;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: transparent;
}
.general{
  background: transparent;
}
#test5-ul {
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  list-style: none;
  width: 90%;
  padding: 0;
  margin: 0;
  margin-left: auto;
  margin-right: auto;
  padding-top: 0px;
  position: relative;

}

#test5-ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 100%;
  width: 100%;
  margin-bottom: 0px;
  position: inherit;
  z-index: 0;
}
.vueActive, .vueLiNone {
  height: 100%;
}
.modeleBase li {
  background-color: transparent;
}
.modeleBase li button {
  border: none;
  border-radius: 15px;
  background-color: #473334;
  color: white;
  width: 100%;
  }
.selected {
  background-color: #54c7da !important;
  border-radius: 25px;
  cursor: pointer;
}
.modeleBase li button:hover{
  background-color: #54c7da !important;
  border-radius: 25px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Test/Test_5.vue